import React from 'react';

export const MediaMentions = () => {
    return (
        <div className="media-mentions">
            <h3>KdeToSakra v závěrečných pracích a v médiích</h3>
            <p>
                Hra <i>Kde to sakra?</i> se objevila v několika bakalářských a diplomových pracích zaměřených na využití
                digitálních nástrojů ve výuce zeměpisu.
            </p>

            <h4>Závěrečné práce</h4>
            <ul>
                <li>
                    <b>Haisová, A.</b> (2023):{' '}
                    <a
                        href="https://dspace.zcu.cz/bitstreams/2b3d5921-0ed2-440a-b326-917df07d5f8e/download"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Využití vybraných aplikací ve výuce zeměpisu
                    </a>
                    . Bakalářská práce, Západočeská univerzita v Plzni, Pedagogická fakulta.
                    <br />
                    <small>
                        V práci je <i>Kde to sakra</i> hodnocena jako jedna z aplikací (včetně tabulky technických a
                        didaktických parametrů).
                    </small>
                </li>
                <li>
                    <b>Orság, M.</b> (2022):{' '}
                    <a
                        href="https://dspace.jcu.cz/bitstream/handle/20.500.14390/46121/Diplomova_prace_Orsag.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Aktivizační výuka zeměpisu zaměřená na mezipředmětové vztahy dějepisu a zeměpisu
                    </a>
                    . Diplomová práce, Jihočeská univerzita v Českých Budějovicích, Pedagogická fakulta.
                    <br />
                    <small>
                        Autor popisuje využití aplikace <i>Kde to sakra?</i> jako aktivity pro orientaci v prostoru.
                    </small>
                </li>
                <li>
                    <b>Mitrengová</b> (2023):{' '}
                    <a
                        href="https://theses.cz/id/3jnewo/Mitrengova_BP_Archive.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Webové portály zaměřené na výuku geografie
                    </a>
                    . Bakalářská práce.
                    <br />
                    <small>
                        V práci je zmíněno, že <i>Kde to sakra?</i> je online hra pro poznávání míst.
                    </small>
                </li>
                <li>
                    <b>Valíková, B. V.</b>:{' '}
                    <a
                        href="https://is.muni.cz/th/zizwd/Valikova_diplomova_prace.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Možnosti zapojení informačních technologií do výuky zeměpisu na středních školách
                    </a>
                    . Diplomová práce, Masarykova univerzita.
                    <br />
                    <small>KdeToSakra.cz je uvedena mezi příklady digitálních nástrojů pro výuku.</small>
                </li>
                <li>
                    <b>Slošarová, B.</b> (2021):{' '}
                    <a href="https://is.muni.cz/th/wkae6/" target="_blank" rel="noopener noreferrer">
                        Koncepce terénní výuky zeměpisu na základní škole v Brně
                    </a>
                    . Masarykova univerzita.
                    <br />
                    <small>Odkaz na kdetosakra.cz je uveden mezi zdroji v textu práce.</small>
                </li>
                <li>
                    <b>Ševčíková, K.</b>:{' '}
                    <a
                        href="https://theses.cz/id/jfp57q/Diplomova_prace_Sevcikova_Kristyna_.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Online výzvy – mentoring
                    </a>
                    . Diplomová práce.
                    <br />
                    <small>
                        V dokumentu je položka <i>KdeToSakra – online hra inspirovaná GeoGuessr</i>.
                    </small>
                </li>
            </ul>

            <h4>V televizi</h4>
            <ul>
                <li>
                    <a
                        href="https://decko.ceskatelevize.cz/video/e221553110030012"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Česká televize – pořad Tamtam
                    </a>{' '}
                    (Déčko, 20. 3. 2021, cca od 18. minuty) – hra <i>Kde to sakra?</i> byla představena jako tip na
                    víkendovou zábavu pro děti a jejich rodiče
                </li>
            </ul>

            <h4>Vzdělávací a metodické materiály</h4>
            <ul>
                <li>
                    <a
                        href="https://digitalizace.rvp.cz/sov/clanky/pomahaji-se-zaclenovanim-digitalnich-technologii"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        NPI / RVP – Digitalizace ve vzdělávání
                    </a>{' '}
                    (2024) – článek o začleňování digitálních technologií do výuky zeměpisu
                </li>
                <li>
                    <a
                        href="https://www.lideazeme.cz/clanek/lideazeme-cz-pr-clanky/125426/pocitacove-hry-s-nadechem-geografie-uz-jste-si-zahrali.html"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Lidé a Země
                    </a>{' '}
                    – článek <i>Počítačové hry s nádechem geografie</i>
                </li>
                <li>
                    <a
                        href="https://www.projektsypo.cz/blog/51-staticke-stranky/blog/681-zemepis-poutave-aplikace-zpestri-vyuku-nejen-v-karantene.html"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Projekt SYPO
                    </a>{' '}
                    – systém podpory profesního rozvoje učitelů a ředitelů
                </li>
                <li>
                    <a href="https://zdroje.guruveskole.cz/kde-to-sakra/" target="_blank" rel="noopener noreferrer">
                        Zdroje ve škole / Guru ve škole
                    </a>{' '}
                    – kurz pro učitele
                </li>
                <li>
                    <a
                        href="https://www.eduteam.cz/inspirace-pro-vyuku/kde-to-sakra/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        EDUTEAM
                    </a>{' '}
                    – inspirace pro výuku
                </li>
                <li>
                    <a href="https://www.sskola.cz/geoguessr-kdetosakra/" target="_blank" rel="noopener noreferrer">
                        (S)Škola
                    </a>{' '}
                    – vzdělávací blog pro učitele
                </li>
                <li>
                    <a
                        href="https://zachranzemepis.cz/hra-geoguessr-se-kterou-prozkoumate-svet/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Zachraň zeměpis
                    </a>{' '}
                    – portál pro učitele zeměpisu
                </li>
                <li>
                    <a
                        href="https://www.gjp1.cz/dokumenty/2020-21/Prirucka_zacl_zaku_s_odl_mat_jazykem.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        GJP1 – Příručka pro školní praxi
                    </a>{' '}
                    – seznam online zdrojů pro výuku
                </li>
                <li>
                    <a
                        href="https://kurzzapalovac.cz/blog/nejlepsi-online-aktivity-k-pouziti-pro-vyuku-i-oddilovou-cinnost/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Kurz Zapalovač
                    </a>{' '}
                    – metodické tipy pro online aktivity
                </li>
            </ul>
        </div>
    );
};
